import { Component, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { TopComponent } from "../component/top/top.component";
import { NotFoundComponent } from "../component/notfound/notfound.component";
var FlowComponent = /** @class */ (function () {
    function FlowComponent(router, resolver, ref, route) {
        this.router = router;
        this.resolver = resolver;
        this.ref = ref;
        this.route = route;
    }
    FlowComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log(this.router);
        this.route.data.subscribe(function (data) {
            console.log(data.meta);
            if (typeof data.meta === 'undefined') {
                _this.ref.createComponent(_this.resolver.resolveComponentFactory(NotFoundComponent), 0);
            }
            else {
                if (_this.router.url === '/top') {
                    _this.ref.createComponent(_this.resolver.resolveComponentFactory(TopComponent), 0);
                }
            }
        });
    };
    FlowComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'flow',
                    // templateUrl: 'flow.component.html',
                    template: '<router-outlet></router-outlet>'
                }] }
    ];
    /** @nocollapse */
    FlowComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ComponentFactoryResolver },
        { type: ViewContainerRef },
        { type: ActivatedRoute }
    ]; };
    return FlowComponent;
}());
export { FlowComponent };
//# sourceMappingURL=flow.component.js.map